<!-- <ion-grid class="confirmation-body"> -->
  <mat-dialog-actions>
    <ion-row class="col-md-reverse w-100">
      <ion-col size="12" size-md class="phi-align-content-center">
        <div class="phi-flex-wrap-center-space-between phi-gap-12">
          <div *ngIf="popupName == 'Competency Set'" class="fs-18 fs_16ForMobile font_bold cl-black">Competency Set Status: ({{competencyemployee.length}})</div>
          <div *ngIf="popupName == 'Evaluated by Manager'" class="fs-18 fs_16ForMobile font_bold cl-black">Evaluated by Manager: ({{competencyemployee.length}})</div>
          <div class="mb-md-15">
            <label *ngIf="popupName == 'Competency Set'" class="mr-10">Incomplete</label>
            <!-- <label *ngIf="popupName == 'Evaluated by Manager'" class="mr-10">Not Evaluated</label> -->
            <mat-slide-toggle class="mr-10" [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
            <label *ngIf="popupName == 'Competency Set'" class="mr-10">Completed</label>
            <!-- <label *ngIf="popupName == 'Evaluated by Manager'" class="mr-10">Evaluated</label> -->
            <label *ngIf="popupName == 'Evaluated by Manager'" class="mr-10">
              {{ isToggleOn ? 'Evaluated' : 'Not Evaluated' }}
            </label>
          </div>
        </div>
      </ion-col>
      <ion-col size="12" size-md="auto" class="phi-align-content-center">
	      <div class="popup-close phi-justify-content-end mb-md-15">
          <button (click)="exportDashboardListExcel()" class="mr-10 Download fs-16 fs_14ForMobile font_semibold">
            <img src="././assets/icon/yellowdownload.png" class="downIcon">
            <span *ngIf="!mobileResponsiveService.hideForMobile">Download</span>
          </button>
          <div class="close_bg display-center cp" [mat-dialog-close]>
            <img src="././assets/icon/close_icon.png" class="closeHeight">
          </div>
        </div>
      </ion-col>
    </ion-row>
</mat-dialog-actions>
<!-- </ion-grid> -->
<mat-dialog-content>
  <div class="table-scroll" *ngIf="popupName == 'Competency Set'">
    <table class="hover mb-15">
      <thead>
        <tr>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Dept/Function</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">{{setupGradeBrand}}</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Competency Name</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Competency Defination</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">WT</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Published On</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Created By</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Last Modified By</th>
        </tr>
      </thead>
      <tbody *ngIf="!isToggleOn">
        <ng-container *ngFor="let item of competencyemployee; let empIndex = index">
          <!-- <ng-container *ngFor="let competency of item.competencyMasterlist; let i = index"> -->
            <tr>
              <ng-container>
                <td class="fs-14 fs_12ForMobile font_regular">
                  {{ item.functionName }}
                </td>
                <td class="fs-14 fs_12ForMobile font_regular">
                  {{ item.band }}
                </td>
              </ng-container>
              <td class="fs-14 fs_12ForMobile font_regular"></td>
              <td class="fs-14 fs_12ForMobile font_regular"></td>
              <td class="fs-14 fs_12ForMobile font_regular"></td>
              <td class="fs-14 fs_12ForMobile font_regular"></td>
              <td class="fs-14 fs_12ForMobile font_regular"></td>
              <td class="fs-14 fs_12ForMobile font_regular"></td>
            </tr>
          <!-- </ng-container> -->
          <!-- <tr class="total-row">
            <td colspan="5" class="fs-14 fs_12ForMobile font_bold cl-black text-right"></td>
            <td class="fs-14 fs_12ForMobile font_bold cl-black">
            </td>
            <td colspan="4"></td>
          </tr> -->
        </ng-container>
      </tbody>
      <tbody *ngIf="isToggleOn">
        <ng-container *ngFor="let item of competencyemployee; let empIndex = index">
          <ng-container *ngFor="let competency of item.competencyMasterlist; let i = index">
            <tr>
              <ng-container *ngIf="i === 0">
                <td class="fs-14 fs_12ForMobile font_regular" [attr.rowspan]="item.competencyMasterlist.length">
                  {{ item.functionName }}
                </td>
                <td class="fs-14 fs_12ForMobile font_regular" [attr.rowspan]="item.competencyMasterlist.length">
                  {{ item.band }}
                </td>
              </ng-container>
              <td class="fs-14 fs_12ForMobile font_regular">{{ competency?.competencyName }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ competency?.competencyDefination }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ competency?.weightageNo }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.formattedPublishedOn}}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.createdBy }} | {{ item.formattedCreatedAt }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.lastModifiedBy }} | {{ item.formattedLastModifiedOn }}</td>
            </tr>
          </ng-container>
          <tr class="total-row">
            <td colspan="4" class="fs-14 fs_12ForMobile font_bold cl-black text-right"></td>
            <td class="fs-14 fs_12ForMobile font_bold cl-black">Total <span class="orangecolor">{{getTotalWeight(item)}}</span>
            </td>
            <td colspan="4"></td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div class="table-scroll" *ngIf="popupName == 'Evaluated by Manager'">
    <table class="hover mb-15">
      <thead>
        <tr>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Employee Name</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Manager name</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Dept/Function</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">{{setupGradeBrand}}</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Evaluated date</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Score</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Rating</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Manager Comment</th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">Employee Comment</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of competencyemployee; let empIndex = index">
            <tr>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.employeeName }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.managerName }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.function }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.band }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.evaluatedDate|date:'dd-MM-yyyy | hh:mm a' }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.score }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.rating }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.managerComment }}</td>
              <td class="fs-14 fs_12ForMobile font_regular">{{ item.employeeComment }}</td>
            </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</mat-dialog-content>